import { Box, Card, CardActionArea, CardActions, CardContent, type SxProps, Typography } from '@mui/material'
import 'Components/Cards/Large/LargeCard.css'

interface LargeCardProps {
  header?: string
  content: JSX.Element
  className?: string
  contentClassName?: string
  headerClassName?: string
  fullWidth?: boolean
  customContentWidth?: boolean
  icon?: JSX.Element
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  actions?: JSX.Element
  noWrapHeader?: boolean
  sx?: SxProps
  contentSx?: SxProps
}

export const LargeCard = (props: LargeCardProps): JSX.Element => {
  const { header, content, className, contentClassName, headerClassName, fullWidth, customContentWidth, icon, onClick, contentSx, ...other } = props

  const onCardClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    if (onClick != null) {
      onClick(event)
    }
  }

  const cardContent = <CardContent
    sx={{ display: 'flex', flexDirection: 'column', width: customContentWidth === true ? 'unset' : '100%', ...contentSx }}
    className={contentClassName}
  >
    {header != null && <Typography style={{ display: (props.noWrapHeader ?? false) ? '' : 'inline-block', whiteSpace: 'pre-line' }}
      data-testid='cardHeader' component="div" variant="h5"
      className={'d-flex f-align-items-center ' + (headerClassName ?? '')}
    >{header}{icon}</Typography>}
    {content}
  </CardContent>

  return (
    <Card sx={{
      maxWidth: fullWidth === true ? '100%' : 345,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '32px',
      cursor: props.onClick !== undefined ? 'pointer' : 'default',
      ...props.sx
    }} className={className} {...other}
    >
      {props.onClick !== undefined && (<>
        <CardActionArea onClick={(e) => { onCardClick(e) }}>
          <Box >
            {cardContent}
          </Box>
        </CardActionArea>
        {props.actions !== undefined && <CardActions sx={{ alignItems: 'flex-end', p: 0 }}>
          {props.actions}
        </CardActions>}
      </>
      )}
      {props.onClick === undefined && (<>
        {cardContent}
      </>
      )}
    </Card>
  )
}
